import type { SupportedLanguage } from './index'

/**
 * Define localized routes here.
 * Each key maps to a route name, with translations for each language.
 *
 * Example:
 *   about: { it: 'chi-siamo', en: 'about-us' }
 *   → /it/chi-siamo, /en/about-us
 */
export const localizedRoutes = {
  home: {
    it: '',
    en: '',
    fr: '',
    es: '',
    de: '',
    pt: '',
    pl: '',
  },
  azienda: {
    it: 'azienda',
    en: 'company',
    fr: 'entreprise',
    es: 'empresa',
    de: 'unternehmen',
    pt: 'empresa',
    pl: 'firma',
  },
  persone: {
    it: 'persone',
    en: 'people',
    fr: 'equipe',
    es: 'equipo',
    de: 'team',
    pt: 'equipa',
    pl: 'zespol',
  },
  servizi: {
    it: 'servizi',
    en: 'services',
    fr: 'services',
    es: 'servicios',
    de: 'leistungen',
    pt: 'servicos',
    pl: 'uslugi',
  },
  contacts: {
    it: 'contatti',
    en: 'contacts',
    fr: 'contacts',
    es: 'contactos',
    de: 'kontakt',
    pt: 'contactos',
    pl: 'kontakt',
  },
  privacy: {
    it: 'privacy',
    en: 'privacy',
    fr: 'privacy',
    es: 'privacy',
    de: 'datenschutz',
    pt: 'privacidade',
    pl: 'privacy',
  },
} as const

export type RouteKey = keyof typeof localizedRoutes

/**
 * Get the localized path for a route
 */
export function getLocalizedPath(
  routeKey: RouteKey,
  lang: SupportedLanguage
): string {
  const path = localizedRoutes[routeKey][lang]
  return path ? `/${lang}/${path}` : `/${lang}`
}

/**
 * Find route key from a path segment
 */
export function findRouteKeyFromPath(
  pathSegment: string,
  lang: SupportedLanguage
): RouteKey | null {
  for (const [key, routes] of Object.entries(localizedRoutes)) {
    if (routes[lang] === pathSegment) {
      return key as RouteKey
    }
  }
  return null
}
